/** @format */

import React from "react";

const PropertyApp = () => {
  return (
    <section className="container">
      <h1 className="headline">Privacy Policy for Flyweis Property App</h1>
      <p>Effective Date: 26/12/2024</p>
      <p>
        At Flyweis Property App, we are committed to protecting and respecting
        your privacy. This Privacy Policy explains how we collect, use, store,
        and protect your personal data when you use our property rental, buying,
        selling, or other real estate services ("Services") provided through the
        app.
      </p>
      <h3>1. Information we collect</h3>
      <p>
        We collect different types of personal and non-personal information when
        you use our Services:
      </p>
      <p>Personal Information:</p>
      <p>
        Name <br />
        Email address <br />
        Phone number <br />
        Payment information (for booking or purchasing properties, if
        applicable) <br />
        Address or location details (for property searches) <br />
        Preferences or interests related to property search (type of property,
        price range, etc.) <br />
        Property Information:
      </p>
      <p>
        Details about properties you are interested in (e.g., addresses,
        features, prices, and conditions) <br />
        Photos or videos of properties that you upload or view <br />
        Location Information:
      </p>
      <p>
        We may collect location data (if enabled) to show you nearby properties
        or provide location-based services.
        <br />
        Device Information:
      </p>
      <p>
        Information about the device you use to access our app (IP address,
        device type, operating system, browser type, mobile carrier, etc.).
        <br />
        Usage Data:
      </p>
      <p>
        Data on how you use the app (such as the properties you search for,
        features you use, and time spent on the app). <br />
        Communications:
      </p>
      <p>
        Messages, inquiries, or feedback you send through the app or contact
        forms.
      </p>
      <h4>2. How we use your information</h4>
      <p>We use your information for the following purposes:</p>
      <p>Provide and Improve Our Services:</p>
      <p>
        To help you find properties, connect with agents or property owners, and
        facilitate the booking or purchase process.
        <br />
        Account Management:
      </p>
      <p>
        To create, manage, and personalize your user account, including
        providing tailored property recommendations.
        <br />
        Customer Support:
      </p>
      <p>
        To respond to your inquiries, resolve issues, and provide support
        related to properties or your account.
        <br />
        Transaction Processing:
      </p>
      <p>
        To process payments for property bookings, rentals, or purchases, and to
        send related receipts and notifications.
        <br />
        Marketing and Promotions:
      </p>
      <p>
        To send you marketing materials, property recommendations, or
        promotional offers. You can opt-out of these communications at any time.
        <br />
        Analytics and Improvements:
      </p>
      <p>
        To analyze app usage patterns and improve the functionality and user
        experience of our app.
      </p>

      <h4>3. How we share your information</h4>
      <p>We may share your personal information with the following parties:</p>
      <p>Property Agents and Sellers:</p>

      <p>
        If you inquire about or book a property, we may share your information
        with the relevant property owners, agents, or sellers to facilitate the
        process.
        <br />
        Third-Party Service Providers:
      </p>

      <p>
        We may share your information with service providers who assist with
        payment processing, customer support, app analytics, or marketing
        services. <br />
        Legal Compliance:
      </p>

      <p>
        We may disclose your personal information if required by law or in
        response to legal requests, such as subpoenas or court orders.
        <br />
        Business Transactions:
      </p>

      <p>
        In the event of a merger, acquisition, or sale of assets, your personal
        information may be transferred as part of the transaction.
      </p>

      <h4>4. Data Security</h4>

      <p>
        We use reasonable security measures to protect your personal data,
        including encryption, secure servers, and access controls. However, no
        method of data transmission over the internet is 100% secure, and we
        cannot guarantee complete security of your data.
      </p>

      <h4>5. Your Rights and Choices</h4>
      <p>You have the following rights regarding your personal data:</p>
      <p>Access and Update:</p>

      <p>
        You can access and update your personal information directly in the app
        or by contacting us. <br />
        Data Deletion:
      </p>

      <p>
        You can request the deletion of your personal information or account,
        subject to any legal obligations we may have.
        <br />
        Opt-out of Marketing:
      </p>

      <p>
        You can opt-out of receiving marketing communications at any time by
        following the unsubscribe instructions in emails or through the app's
        settings. <br />
        Location Permissions:
      </p>
      <p>
        You can control or disable location tracking through your device
        settings, although doing so may limit the functionality of certain
        features in the app.
      </p>

      <h4>6. Data Retention</h4>
      <p>
        We retain your personal data for as long as necessary to provide our
        Services, comply with legal obligations, resolve disputes, and enforce
        our agreements. When no longer needed, your personal information will be
        securely deleted or anonymized.
      </p>
      <h4>7. Third-Party Links</h4>
      <p>
        Our app may contain links to third-party websites or services that are
        not operated by us. We are not responsible for the privacy practices of
        those third parties. We recommend reviewing the privacy policies of any
        third-party websites or services you visit.
      </p>
      <h4>8. Changes to This Privacy Policy</h4>
      <p>
        We may update this Privacy Policy from time to time to reflect changes
        in our practices or legal requirements. Any changes will be posted
        within the app, and we will notify you of significant changes. Please
        review this Privacy Policy periodically to stay informed.
      </p>
      <h4>9. Contact Us</h4>
      <p>
        For any questions or concerns regarding this Privacy Policy, please
        contact us at info@flyweis.technology. <br />
        By using the App, you acknowledge that you have read, understood, and
        agreed to this Privacy Policy.
      </p>
    </section>
  );
};

export default PropertyApp;
